import _ from "lodash";
import { useCallback } from "react";
import FilterIcon from "../../../icons/FilterIcon";
import GridIcon from "../../../icons/GridIcon";
import ListIcon from "../../../icons/ListIcon";
import Button from "../../../toolkit/ButtonV1";
//import {Button} from "@mui/material";
import FormControl from "../../../components/FormControl";
import { useState } from "react";
import { useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";


import { Card, Grid, Box, CardContent, Divider } from "@mui/material";

import { useTranslation } from "react-i18next";
import "../../../Localization/i18n";

//import DashboardTopContainerTitle from "../DashboardTopContainerTitle";
import "../Dashboard.css";
import DashboardTopContainerCard from "../DashboardTopContainerCard";

import Upload from "../../../icons/Upload";
import File from "../../../icons/File";
import File1 from "../../../icons/File1";
import Finacial from "../../../icons/Financial";

import fileDownload from 'js-file-download'
import axios from "../../../utils/fvAxios";
import Menu from "@mui/material/Menu";
import { MenuItem } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";

import { CSVLink } from "react-csv";
import GetfVDateFormate from "../../../utils/Genaricfunctions";

const searchDebounceDelay = 1000;

export default function ({
    searchStr: parentSearchStr,
    setSearchStr: parentSetSearchStr,
    viewType,
    toggleViewType,
    largeScreen,
    countInfo,
    IsDownload,
    Type: val,
    CardType
}) {
    const [searchStr, setSearchStr] = useState(parentSearchStr);
    const debouncedSearchQueryHandler = useCallback(
        _.debounce(parentSetSearchStr, searchDebounceDelay),
        []
    );

    useEffect(() => {
        if (parentSearchStr !== searchStr) {
            debouncedSearchQueryHandler(searchStr);
        }
    }, [searchStr]);


    const { t } = useTranslation();

    const headers = [
        { label: "VendorName", key: "vendorName" },
        { label: "ClientName", key: "clientName" },
        { label: "Purpose", key: "purpose" },
        { label: "EmailSentDate", key: "emailSentDate" }
    ]
    function convertToCSV(data) {
        const header = headers.map(header => `"${header.label}"`).join(',');
        const rows = data.map(item =>
            headers.map(header => `"${item[header.key]}"`).join(',')
        );

        return [header, ...rows].join('\n');
    }

    const [download, setDownload] = useState(null);

    const [downloading, setDownloading] = useState(false);

    const handleDownload = () => {
        setDownloading(true)
        axios.get(IsDownload + "&isDownload=" + true)
            .then((res) => {
                setDownload(res?.data?.data);
                if (res.data.data) {
                    const csvContent = convertToCSV(res?.data?.data);
                    const blob = new Blob([csvContent], { type: 'text/csv' });
                    const url = URL.createObjectURL(blob);

                    const a = document.createElement('a');
                    a.href = url;
                    a.download = 'Notifications.csv';
                    a.click();
                    URL.revokeObjectURL(url);
                }
            })
            .catch((error) => {
                //console.error('API request failed:', error);
            }).finally(() => {
                setDownloading(false)
            })
    }

    const ITEM_HEIGHT = 50;

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <Box>

            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    padding: "10px",
                    "& svg": {
                        m: 1.5,
                    },
                    "& hr": {
                        mx: 0.5,
                    },
                    backgroundColor: "#fff"
                }}
            >
                <h2 className="dashBoardtext">{t("Dashboard.notifications")}</h2>
                <div className="styles">
                    <FormControl

                        className="buttonhidden"
                        inputType="text"
                        placeholder="Search"
                        value={searchStr}
                        handleChange={setSearchStr}
                    />
                </div>

                <Box sx={{ display: "flex" }} >
                    <Card
                        hidden={downloading == true}
                        onClick={handleDownload}
                        style={{
                            width: "90px",
                            cursor: "pointer",
                            textDecoration: "none",
                            color: "#101828",
                            borderStyle: "solid",
                            borderColor: "#E4E7EC",
                            borderRadius: "4px",
                            marginRight: "5px",
                            marginLeft: "10px",
                        }}
                    >
                        <span className="mx-1">{t("Dashboard.download")}</span>
                    </Card>
                    <CircularProgress hidden={downloading == false} />
                </Box>

                {largeScreen && (
                    <Button
                        className="buttonhidden"
                        role="tertiary"
                        size="default"
                        trailingComponent={
                            viewType === "list" ? <GridIcon /> : <ListIcon />
                        }
                        onClick={toggleViewType}
                    />
                )}
            </Box>
            <Box
                className="media"
                sx={{
                    display: "flex",
                    alignItems: "center",
                    paddingLeft: "15px",
                    "& svg": {
                        m: 1.5,
                    },
                    "& hr": {
                        mx: 0.5,
                    },
                }}
            >
                <div className="styles">
                    <FormControl
                        sx={{ width: "200px", marginRight: "auto" }}
                        inputType="text"
                        placeholder="Search"
                        value={searchStr}
                        handleChange={setSearchStr}
                    />
                </div>
                <IconButton
                    sx={{ marginLeft: "auto", cursor: 'pointer' }}
                    aria-label="more"
                    id="long-button"
                    aria-controls={open ? "long-menu" : undefined}
                    aria-expanded={open ? "true" : undefined}
                    aria-haspopup="true"
                    onClick={handleClick}
                >
                    <MoreVertIcon />
                </IconButton>
                <Menu
                    id="long-menu"
                    MenuListProps={{
                        "aria-labelledby": "long-button",
                    }}
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    PaperProps={{
                        style: {
                            maxHeight: ITEM_HEIGHT * 4.5,
                            width: "20ch",
                        },
                    }}
                >

                    {/* <MenuItem onClick={handleClose}> <a style={{ textDecoration: "none", cursor: 'pointer', color: "black" }} onClick={handleDownload}>
                        {t("Dashboard.download")}
                    </a></MenuItem> */}
                </Menu>
            </Box>


        </Box>
    );
}
